import React from 'react';
import PropTypes from "prop-types";
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";

import AuthLayout from "../../shared/containers/AuthLayout";
import {getSeniors} from "../members/actions/seniorsAction";
import ImageUploader from "../../shared/components/ImageUploader";
import * as messageAction from "./actions/messageAction";
import {RC_USER_PREFIX_T} from "../../shared/modules/rocketChat/constants";
import {ANALYTICS_SPECS} from '../../shared/constants';


export class ImageContainer extends React.Component {
  static propTypes = {
    seniors: PropTypes.array
  };

  static defaultProps = {
    seniors: []
  };

  state = {
    image: { file: null, url: '' },
    senior: null
  };

  sendImage = () => {
    const {image, senior} = this.state;

    this.props.dispatch(messageAction.sendImage(image, senior));
    this.props.history.goBack();
  };

  async componentDidMount() {
    const { dispatch, match } = this.props;
    const seniors = await dispatch(getSeniors());
    const senior = messageAction.getSeniorByHash(seniors, match.params.seniorHash);

    this.startMessaging(senior);
    this.setState({ senior });
  }

  setImage = (image) => {
    this.setState({ image });
  };

  startMessaging(senior) {
    this.props.dispatch(messageAction.start(RC_USER_PREFIX_T + senior.prof_id));
  }

  render() {
    const {senior, image} = this.state;
    const title = senior
      ? `${senior.firstname} ${senior.lastname}`
      : '';

    return (
      <AuthLayout
          title={title}
          onBackLink={this.props.history.goBack}
          headerClass="shortHeader">
        <ImageUploader onChange={this.setImage} imagePreviewUrl={image.url} analyticsCategory={ANALYTICS_SPECS.MESSAGING.NAME} />

        <div className="messageImageContainer">
          {image.url && <button
            className="buttonPrimary"
            onClick={this.sendImage}
          >
            {__("Send a picture")}
          </button>}
        </div>

      </AuthLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    seniors: state.seniors
  };
};

export default withRouter(connect(mapStateToProps)(ImageContainer));
